import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
import { config, validateEnv } from "./config/env";

// Validate environment variables on startup
validateEnv();

// Initialize Sentry - MUST be done before React renders
if (config.sentry.enabled) {
  Sentry.init({
    dsn: config.sentry.dsn,
    integrations: [
      // Automatically capture React component errors
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Capture 10% of all sessions for replay
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring
    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% of sessions will be recorded
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors will be recorded
    // Environment
    environment: config.sentry.environment,
    // Release tracking
    release: config.sentry.release,
    // Before sending events, add additional context
    beforeSend(event, hint) {
      // Add localStorage data for debugging form issues
      if (event.exception) {
        try {
          const formDraft = localStorage.getItem('beautyForm_draft');
          const errorLogs = localStorage.getItem('beautyForm_errorLogs');
          const failedSubmission = localStorage.getItem('beautyForm_failedSubmission');

          event.contexts = event.contexts || {};
          event.contexts.localStorage = {
            hasFormDraft: !!formDraft,
            hasErrorLogs: !!errorLogs,
            hasFailedSubmission: !!failedSubmission,
            formDraftAge: formDraft ? Date.now() - JSON.parse(formDraft).timestamp : null,
          };
        } catch (e) {
          console.error('Error adding localStorage context to Sentry:', e);
        }
      }
      return event;
    },
  });

  console.log('✅ Sentry initialized');
} else {
  console.warn('⚠️ Sentry DSN not found - error tracking disabled');
}

createRoot(document.getElementById("root")!).render(<App />);
